import { Button, Dropdown, Menu, message } from "antd";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import DeleteConfirm from "components/DeleteConfirm";
import React, { useContext } from "react";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../../../Store";
import AddGroupActivityModal from "../AddGroupActivityModal";
import useModalHandler from "utils/useModalHandler";
import {
    cancelGroupActivityBatch,
    deleteGroupActivityBatch,
    GroupListItem,
    publishGroupActivityBatch
} from "service/group";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import { useSetAtom } from "jotai";
import { FlagAtom, TouchedAtom } from "../../store";
import SubmitError from "components/SubmitError";
import CopyActivityModal from "../CopyActivityModal";
import useRequestFn from "../../../../../utils/useRequestFn";

interface GroupProps {
    select: CheckboxValueType[]; //选中项id
    setSelect: (val: CheckboxValueType[]) => void;
    refreshData: () => void; //更新列表数据
    groupList: GroupListItem[];
}

export default function Group({
    select,
    setSelect,
    refreshData,
    groupList
}: GroupProps) {
    const addModal = useModalHandler();
    const copyModal = useModalHandler();
    const history = useHistory();
    const { basename } = useContext(CourseContext);
    const updateTouched = useSetAtom(TouchedAtom);
    const updateFlag = useSetAtom(FlagAtom);

    //添加活动
    const onAddActivity = () => {
        addModal.open();
        updateFlag("add");
    };

    //保存但不关闭弹窗
    const onOk = () => {
        refreshData();
        updateTouched(false);
    };

    //删除
    const onDelete = async () => {
        const params = select?.map(item => ({ id: item }));
        try {
            await deleteGroupActivityBatch(params);
            await onReset();
            message.success("删除成功");
        } catch (e) {
            ResultMessage.error(
                <SubmitError title="删除失败" content={errorMessage(e)} />,
                { width: 300 }
            );
        }
    };

    //发布

    const [onSubmit, { loading }] = useRequestFn(publishGroupActivityBatch);

    const onPublish = async () => {
        const params = select?.map(item => ({ id: item }));
        try {
            await onSubmit(params);
            await onReset();
            message.success("发布成功");
        } catch (e) {
            ResultMessage.error(
                <SubmitError title="发布失败" content={errorMessage(e)} />,
                { width: 300 }
            );
        }
    };

    //取消发布
    const onCancelPublish = async () => {
        try {
            await cancelGroupActivityBatch(select);
            await onReset();
            message.success("取消发布成功");
        } catch (e) {
            ResultMessage.error(
                <SubmitError title="取消发布失败" content={errorMessage(e)} />,
                { width: 300 }
            );
        }
    };

    //复制成功
    const onCopySuccess = () => {
        copyModal.close();
        refreshData();
    };

    //重置
    const onReset = () => {
        refreshData();
        setSelect([]);
    };

    //下拉菜单
    const actionMenu = (
        <Menu>
            <Menu.Item>
                <DeleteConfirm
                    title="确认删除小组活动吗？"
                    content="删除小组活动将同时删除小组活动任务及学生作答结果，请谨慎操作。"
                    onSuccess={onDelete}>
                    <Button disabled={!select.length} type="link">
                        批量删除
                    </Button>
                </DeleteConfirm>
            </Menu.Item>
            <Menu.Item>
                <Button
                    disabled={!select.length}
                    type="link"
                    loading={loading}
                    onClick={onPublish}>
                    批量发布
                </Button>
            </Menu.Item>
            <Menu.Item>
                <DeleteConfirm
                    title="确认取消发布小组活动吗？"
                    content="取消发布后，学生将无法查看小组活动。"
                    onSuccess={onCancelPublish}>
                    <Button disabled={!select.length} type="link">
                        批量取消发布
                    </Button>
                </DeleteConfirm>
            </Menu.Item>
        </Menu>
    );

    return (
        <div className={style.root}>
            <Button
                className={style.group}
                onClick={() => history.push(`${basename}/group/settings`)}>
                小组管理
            </Button>

            {groupList.length !== 0 && (
                <>
                    <Dropdown
                        overlay={actionMenu}
                        placement="bottomCenter"
                        overlayClassName={style.menu}>
                        <Button className={style.setting}>批量操作</Button>
                    </Dropdown>
                    <Button type="primary" ghost onClick={copyModal.open}>
                        <img src={require("./img/icon4.png")} alt="" /> 复制活动
                    </Button>
                </>
            )}

            <Button type="primary" ghost onClick={onAddActivity}>
                <img src={require("./img/icon3.png")} alt="" /> 添加活动
            </Button>

            {addModal.render(
                <AddGroupActivityModal
                    visible={addModal.visible}
                    onCancel={addModal.close}
                    onOk={onOk}
                />
            )}

            {copyModal.render(
                <CopyActivityModal
                    onCancel={copyModal.close}
                    onOk={onCopySuccess}
                />
            )}
        </div>
    );
}
